import { RxMeetingsAPI } from '@driftt/dapper'
import { Observable } from 'rxjs'
import { fromJS } from 'immutable'

export const api = {
  fetchAssistantOrgSettings() {
    return RxMeetingsAPI.get('/assistant/settings/org')
      .checkStatus()
      .mapResponse(fromJS)
  },
  createAssistantOrgSettings(assistantOrgSettings) {
    return RxMeetingsAPI.post('/assistant/settings/org', assistantOrgSettings)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(fromJS)
  },
  patchAssistantOrgSettings(assistantOrgSettings) {
    return RxMeetingsAPI.patch('/assistant/settings/org', assistantOrgSettings)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(fromJS)
      .delayWhen(() => Observable.timer(1000))
  },
  fetchAssistantAgentSettings() {
    return RxMeetingsAPI.get('/assistant/settings/agent')
      .checkStatus()
      .mapResponse(fromJS)
  },
  createAssistantAgentSettings(assistantAgentSettings) {
    return RxMeetingsAPI.post('/assistant/settings/agent', assistantAgentSettings)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(fromJS)
  },
  patchAssistantAgentSettings(assistantAgentSettings) {
    return RxMeetingsAPI.patch('/assistant/settings/agent', assistantAgentSettings)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(fromJS)
  },
  fetchSalesforceSettings() {
    return RxMeetingsAPI.get('/assistant/settings/salesforce_settings')
      .checkStatus()
      .map(res => res.response)
  },
  fetchPersonalizationTags() {
    return RxMeetingsAPI.get('/assistant/settings/email_context')
      .checkStatus()
      .map(res => res.response)
  },
  sendTestEmail(taskType) {
    return RxMeetingsAPI.post('/assistant/settings/test_email', taskType)
      .checkStatus()
      .map(res => res.response)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/assistantSettings/api.js